import { Flex } from "@chakra-ui/react";
import { DEFAULT_LANGUAGE, Language } from "@models/language";
import { BiSupport } from "react-icons/bi";
import { BsDiscord, BsTelegram } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { CardCover, ShowChildrenOnHoverCard } from "../CheckoutSuccessCTA";

const _t = (key?: string, language = DEFAULT_LANGUAGE) => key || "";

interface ContactUsCardInfo {
  email?: string;
  discord?: string;
  telegram?: string;
}

const ContactUsCard = ({
  contactUsCardInfo: { email, discord, telegram } = {},
  language = DEFAULT_LANGUAGE,
}: {
  contactUsCardInfo?: ContactUsCardInfo;
  language?: Language;
}) => (
  <ShowChildrenOnHoverCard
    cover=<CardCover
      icon={<BiSupport />}
      alt="contact us icon"
      title={_t("Contact us", language)}
    />
  >
    <Flex
      direction="row"
      gap={6}
      justifyContent="center"
      width="100%"
      alignItems="center"
      fontSize="1.2em"
      className="text-primary"
    >
      <a
        href={telegram || "https://t.me/pweeh"}
        target="_blank"
        rel="noreferrer"
      >
        <BsTelegram />
      </a>
      <a
        href={`mailto:${email || "support@moongate.id"}`}
        target="_blank"
        rel="noreferrer"
      >
        <MdEmail />
      </a>
      <a
        href={
          discord ||
          "https://discord.com/channels/948159905494335488/948581449802608660"
        }
        target="_blank"
        rel="noreferrer"
      >
        <BsDiscord />
      </a>
    </Flex>
  </ShowChildrenOnHoverCard>
);

export default ContactUsCard;
